export const consoleLog = (...msgs) => console.log(...msgs);
export const emptyLog = () => void 0;
